import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../lib/firebase/config';
import { Verification } from '../types/verification';
import { VerificationDetails } from '../components/verification/VerificationDetails';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { ErrorMessage } from '../components/common/ErrorMessage';

export const VerificationDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [verification, setVerification] = useState<Verification | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchVerification = async () => {
      try {
        if (!id) throw new Error('Verification ID not found');

        const verificationRef = doc(firestore, 'verifications', id);
        const verificationSnap = await getDoc(verificationRef);

        if (!verificationSnap.exists()) {
          throw new Error('Verification not found');
        }

        setVerification({
          id: verificationSnap.id,
          ...verificationSnap.data()
        } as Verification);
      } catch (error: any) {
        console.error('Error fetching verification:', error);
        setError(error.message || 'Failed to load verification details');
      } finally {
        setLoading(false);
      }
    };

    fetchVerification();
  }, [id]);

  const handleDelete = () => {
    navigate('/');
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} />;
  if (!verification) return <ErrorMessage message="Verification not found" />;

  return <VerificationDetails verification={verification} onDelete={handleDelete} />;
};